//ESPAÑOL
import { alcoholTypesES, smokeTypesES } from './translations/es/drugsTypes.js';
import es from './translations/es/translation.json';
import { alcoholTypesRU, smokeTypesRU } from './translations/ru/drugsTypes.js';
import ru from './translations/ru/translation.json';
import { alcoholTypesUA, smokeTypesUA } from './translations/ua/drugsTypes.js';
import ua from './translations/ua/translation.json';

//RUSO
//UCRANIANO
const translations = {
	es: {
		main: es,
		drugs: {
			smoke: smokeTypesES,
			alcohol: alcoholTypesES,
		},
	},
	ru: {
		main: ru,
		drugs: {
			smoke: smokeTypesRU,
			alcohol: alcoholTypesRU,
		},
	},
	ua: {
		main: ua,
		drugs: {
			smoke: smokeTypesUA,
			alcohol: alcoholTypesUA,
		},
	},
};

export default translations;
